export default __webpack_public_path__ + "static/media/driveridentification.11a9dffb.png";